// routes
import { PATH_DASHBOARD } from './routes/paths';

export const FRONTEND_BASE_URL = `${window.location.protocol}//${window.location.host}`;
export const CDN_BASE_URL = 'https://cdn.lapoint.lk/';
export const PRINTER_TOOL_DOWNLOAD_URL = 'https://storage.googleapis.com/bubblemania/PROD_ASSETS/PrinterTool.zip';
// export const BASE_URL = 'https://bubblemelk.expergen.com/';
// export const BASE_URL = 'http://localhost:8080/api/';
export const BASE_URL = process.env?.REACT_APP_BASEURL ? process.env?.REACT_APP_BASEURL : 'http://localhost:8083/api/';
export const ENV = 'BETA';
export const BUSINESS_NAME = 'lapoint.lk';

export const COMPANY_DATA_FOR_PDF = {
  name: 'lapoint (PVT) Ltd',
  address: 'Lapoint Surfcamp Sri Lanka Kabalana Kataluwa, Ahangama',
  phone: '+46 18 800 81 25',
};

export const HOST_API = process.env.REACT_APP_HOST_API_KEY || 'https://minimal-assets-api.vercel.app';

export const FIREBASE_API = {
  apiKey: 'AIzaSyDZ5sftcuSeJYhy9V4jkYj9uUcEJArx9ag',
  authDomain: 'lapoint-suite.firebaseapp.com',
  projectId: 'lapoint-suite',
  storageBucket: 'lapoint-suite.appspot.com',
  messagingSenderId: '236263799180',
  appId: '1:236263799180:web:24f4d2594b2bc091937ea9',
  measurementId: 'G-M0WQNHFZFW',
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.dashboard.root; // as '/dashboard/app'

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeColorPresets: 'red',
  themeLayout: 'vertical',
  themeStretch: true,
};
